<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4.43301 1.82181L11.567 1.82181L15.134 8.00001L11.567 14.1782L4.43301 14.1782L0.866025 8.00001L4.43301 1.82181Z" fill="white" stroke="black" stroke-width="1.5"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M7.5 8.55963V10.5596H8.5V8.55963H10.5V7.55963L8.5 7.55963V5.55963H7.5V7.55963L5.5 7.55963V8.55963H7.5Z" fill="black"/>
</svg>
